"use strict";
/* eslint @typescript-eslint/explicit-module-boundary-types: 0 */
/* eslint @typescript-eslint/no-explicit-any: 0 */
Object.defineProperty(exports, "__esModule", { value: true });
let eventHandlerInited = false;
function initLinks(element) {
    if (eventHandlerInited) {
        return;
    }
    eventHandlerInited = true;
    const pageContent = element.querySelector('.page__content');
    if (pageContent) {
        pageContent.addEventListener('click', (event) => {
            const target = event.target;
            if (!target.matches('a') || event.shiftKey || event.ctrlKey || event.metaKey) {
                return;
            }
            const localLink = target === null || target === void 0 ? void 0 : target.href.startsWith(location.origin);
            const anchorLink = (target === null || target === void 0 ? void 0 : target.pathname) === location.pathname && (target === null || target === void 0 ? void 0 : target.hash);
            if (localLink && !anchorLink) {
                event.preventDefault();
                event.stopPropagation();
                window.routerHistory.push(target.pathname);
            }
        });
    }
}
exports.default = initLinks;
//# sourceMappingURL=links.js.map